import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface IndexInfoVars {
  indexName: string;
}

const GQL_GET_INDEX_INFO = gql`
  query getIndexInfo($indexName: String!) {
    getIndexInfo(indexName: $indexName)
  }
`;

export const useIndexInfoQuery = () => {
  return useLazyQuery<AnyObject, IndexInfoVars>(GQL_GET_INDEX_INFO, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
